import fetcher from '../API';

export const FETCH_ALL_BRANDS = 'FETCH_ALL_BRANDS';
export const FETCH_ALL_BRANDS_FULFILLED = 'FETCH_ALL_BRANDS_FULFILLED';
export const SELECT_BRAND = 'SELECT_BRAND';
export const UPDATE_BRAND = 'UPDATE_BRAND';
export const UPDATE_BRAND_FULFILLED = 'UPDATE_BRAND_FULFILLED ';

export const fetchBrands = () => ( dispatch ) => {
    fetcher.get('api/v1/brands', { f: 0, t: 6500 }).then(res => {
        dispatch({ type: FETCH_ALL_BRANDS_FULFILLED, payload: res })
    })
}

export const selectBrand = (selectBrands) => {
    return {
        type: SELECT_BRAND,
        payload: selectBrands
    };
}

export const updateBrand = (newBrand, callback) => {
    return (dispatch) => {
        dispatch({ type: UPDATE_BRAND });
        fetcher.patch(`api/v1/brands/${newBrand.id}`, { nameCN: newBrand.nameCN, descriptions: newBrand.descriptions })
            .then((response) => {
                callback();
                dispatch({
                    type: UPDATE_BRAND_FULFILLED,
                    payload: response.data
                });
            });
    };
}
